{
    "locale": "uk-UA",
    "General": {
        "OrText": "Або",
        "Title_MyHubert": "My Hubert",
        "Button_GoTo_MyHubert": "Перейти до My Hubert"
    },
    "Header": {
        "ButtonText_CreateNewAccount": "Створити новий обліковий запис",
        "ButtonText_SignInToYourAccount": "Увійдіть до свого облікового запису",
        "ButtonText_StartInterviewWithoutSigningUp": "Почати співбесіду без реєстрації",
        "ButtonText_StartInterviewWithoutSigningIn": "Почати співбесіду без входу",
        "Navlink_Dashboard": "Панель керування",
        "Navlink_MyInterviews": "Мої співбесіди",
        "Navlink_LearnWithHubert": "Навчайтеся з Hubert",
        "Navlink_HelpCenter": "Центр допомоги",
        "MyProfile": "Мій профіль",
        "LogOut": "Вийти"
    },
    "Login": {
        "MainTitle": "Хочете побачити результати своєї співбесіди з Hubert?",
        "Subtitle": "Увійдіть, щоб бачити результати, отримувати відгуки, читати поради та багато іншого.",
        "LoginTitle": "Увійдіть до свого облікового запису Hubert",
        "Label_Email": "Електронна пошта",
        "Label_Password": "Пароль",
        "ButtonText_SignIn": "Увійти",
        "ButtonText_ForgotPassword": "Забули пароль?",
        "ButtonText_ContinueWithGoogle": "Продовжити з Google",
        "OrSeparator": "Або",
        "Error_Email_Required": "Електронна пошта є обов’язковою.",
        "Error_Email_Invalid": "Введіть дійсну адресу електронної пошти.",
        "Error_Password_Required": "Пароль є обов’язковим.",
        "Error_Use_Same_Email_As_Interview": "Будь ласка, використовуйте ту саму електронну пошту, яку вказали під час співбесіди."
    },
    "Registration": {
        "MainTitle": "Хочете побачити результати своєї співбесіди з Hubert?",
        "Subtitle": "Зареєструйтеся, щоб бачити результати, отримувати відгуки, читати поради та багато іншого.",
        "RegistrationTitle": "Створіть обліковий запис Hubert",
        "BenefitsBox_Title": "Ви зможете",
        "BenefitsBox_Point1": "Отримати доступ до історії своїх співбесід",
        "BenefitsBox_Point2": "Отримувати відгуки про ваші співбесіди",
        "BenefitsBox_Point3": "Повторно використовувати відповіді в нових співбесідах",
        "BenefitsBox_Point4": "Отримувати поради щодо співбесід",
        "BenefitsBox_Point5": "Читати кар’єрні гайди",
        "BenefitsBox_Point6": "І багато іншого",
        "Label_FirstName": "Ім’я",
        "Label_LastName": "Прізвище",
        "Label_Email": "Електронна пошта",
        "Label_Password": "Пароль",
        "Label_PhoneNumber": "Номер телефону",
        "Label_TermsOfService": "Я приймаю",
        "Label_TermsOfServiceLink": "Політику конфіденційності та Умови використання",
        "Placeholder_CountryCode": "Виберіть код країни",
        "Placeholder_PhoneNumber": "Напр.,0671234567",
        "HelpText_Password": "Пароль має містити щонайменше 6 символів.",
        "ButtonText_SignUp": "Зареєструватися",
        "ButtonText_SignUpWithGoogle": "Зареєструватися за допомогою Google",
        "OrSeparator": "Або",
        "Error_FirstName_Required": "Ім’я є обов’язковим.",
        "Error_LastName_Required": "Прізвище є обов’язковим.",
        "Error_Email_Required": "Електронна пошта є обов’язковою.",
        "Error_Email_Invalid": "Введіть дійсну адресу електронної пошти.",
        "Error_Email_Exists": "Електронна пошта вже зайнята.",
        "Error_Password_Required": "Пароль є обов’язковим.",
        "Error_Password_6_Characters": "Ваш пароль має містити щонайменше 6 символів.",
        "Error_PhoneNumber_Required": "Номер телефону є обов’язковим.",
        "Error_PhoneNumber_Invalid": "Номер телефону недійсний.",
        "Error_PrivacyPolicyCheck_Required": "Необхідно прийняти Політику конфіденційності та Умови використання."
    },
    "RegistrationInviteEmail": {
        "Subtitle_BeforeInterviewCompleted": "Щоб пройти співбесіду, вам потрібно лише прийняти умови використання Hubert. Просто поставте прапорець, щоб продовжити.",
        "Subtitle_AfterInterviewCompleted": "Зареєструйтеся, щоб бачити результати, отримувати відгуки, читати поради та багато іншого.",
        "PrivacyPolicyText": "Натискаючи «Зареєструватися», ви погоджуєтеся з",
        "PrivacyPolicyLink": "Політикою конфіденційності та Умовами використання",
        "ButtonText_SignUp": "Зареєструватися та перейти до співбесіди",
        "ButtonText_SignUpNormal": "Зареєструватися",
        "ButtonText_SignInInstead": "Натисніть тут, щоб увійти замість цього"
    },
    "LoginInviteEmail": {
        "Subtitle": "Увійдіть, щоб бачити результати, отримувати відгуки, читати поради та багато іншого."
    },
    "AppMessages": {
        "internal-server-error": "Сталася неочікувана помилка.",
        "invalid-credentials": "Недійсні облікові дані. Спробуйте ще раз.",
        "user-not-found": "Недійсні облікові дані. Спробуйте ще раз.",
        "account-not-found": "Недійсний обліковий запис. Спробуйте ще раз.",
        "verify-email-title": "Підтвердьте свою електронну пошту",
        "verify-email-subtitle": "Будь ласка, перевірте електронну пошту, щоб підтвердити обліковий запис.",
        "email-not-verified-title": "Електронну пошту не підтверджено",
        "email-not-verified-subtitle": "Будь ласка, перевірте свою електронну пошту, щоб підтвердити обліковий запис.",
        "verifying-email-title": "Підтвердження електронної пошти",
        "verifying-email-subtitle": "Зачекайте, будь ласка...",
        "sign-in-title": "Вхід",
        "sign-in-subtitle": "Зачекайте, будь ласка...",
        "server-error": "Щось пішло не так.",
        "hubert-user-exists": "Обліковий запис уже існує.",
        "account-exists": "Обліковий запис уже існує.",
        "email-verified": "Вашу електронну пошту підтверджено.",
        "email-is-taken": "Електронна пошта вже зайнята.",
        "re-enter-password": "Використайте свій пароль, щоб увійти",
        "password-reset": "Ваш пароль змінено.",
        "re-enter-new-password": "Використайте свій новий пароль, щоб увійти",
        "invalid-invitation": "Недійсне запрошення.",
        "invalid-code": "Недійсний код підтвердження.",
        "email-already-verified": "Електронну пошту вже підтверджено.",
        "email-mismatch-title": "Невідповідність електронної пошти",
        "email-mismatch-subtitle": "Будь ласка, використовуйте ту саму адресу електронної пошти, яку ви використовували, подаючись на вакансію."
    },
    "TransitionPage": {
        "loading-title": "Завантаження...",
        "loading-subtitle": "Проводимо підготовку...",
        "logout-title": "Завантаження...",
        "logout-subtitle": "Ви виходите з облікового запису..."
    },
    "ImpersonationPage": {
        "loading-title": "Завантаження...",
        "loading-subtitle": "Проводимо підготовку..."
    },
    "ProcessInvitation": {
        "loading-title": "Завантаження...",
        "loading-subtitle": "Зачекайте, ми завантажуємо вашу співбесіду.",
        "InvitationNotFound": "Ми не можемо знайти вашу співбесіду.",
        "InvitationExpired": "Термін дії цього посилання для доступу до співбесіди минув.",
        "InvitationExpired_Description1": "Будь ласка, відкрийте співбесіду з",
        "InvitationExpired_Description2": "Або зв’яжіться зі своїм рекрутером.",
        "InvitationInvalid": "Посилання на це запрошення недійсне.",
        "InterviewCompleted": "Цю співбесіду вже завершено."
    },
    "Common": {
        "MyInterviews": {
            "Title": "Мої співбесіди",
            "TableHead_Employer": "Роботодавець",
            "TableHead_Job": "Посада",
            "TableHead_Status": "Статус",
            "TableHead_ApplicationDate": "Дата подання заявки",
            "TableBody_StartInterview": "Співбесіду не завершено. Натисніть тут, щоб почати або продовжити співбесіду.",
            "TableBody_NotScored": "Співбесіду завершено. Результати будуть доступні найближчим часом.",
            "TableBody_Details": "Натисніть тут, щоб переглянути результати співбесіди та інше.",
            "ApplicationDate_Invited": "Запрошено",
            "ApplicationDate_MinuteAgo": "хвилину тому",
            "ApplicationDate_MinutesAgo": "хвилин тому",
            "ApplicationDate_HourAgo": "годину тому",
            "ApplicationDate_HoursAgo": "годин тому",
            "ApplicationDate_DayAgo": "день тому",
            "ApplicationDate_DaysAgo": "днів тому",
            "ButtonText_SeeAllInterviews": "Переглянути всі співбесіди",
            "ButtonText_Details": "Деталі",
            "ButtonText_StartInterview": "Перейти до співбесіди",
            "ButtonText_NotScored": "Очікування результатів",
            "NoInterviews_Message": "Немає записів про попередні або майбутні співбесіди для вас."
        },
        "LatestJobPostings": {
            "NoJobPostings": "Наразі немає вакансій. Будь ласка, перевірте пізніше."
        }
    },
    "Dashboard": {
        "MyCareer": {
            "Title": "Моя кар’єра",
            "Subtitle": "Виберіть співбесіду, щоб переглянути оцінювання та свої перспективи.",
            "MostRecentInterview": "Найсвіжіша співбесіда",
            "ToDo": "Завдання",
            "NoOngoingInterviews_Title": "У вас немає нових запрошень на співбесіду.",
            "NoOngoingInterviews_Subtitle": "Нові співбесіди Hubert з’являтимуться тут, щойно їх запланують рекрутери.",
            "NoRecentInterviews_Title": "Немає записів про попередні співбесіди.",
            "NoRecentInterviews_Subtitle": "Після того, як вас запросять на співбесіду, вона відображатиметься нижче.",
            "ButtonText_StartInterview": "Перейти до співбесіди",
            "ButtonText_NotScored": "Очікування результатів",
            "ButtonText_Details": "Деталі"
        },
        "LearnWithHubert": {
            "Title": "Навчайтеся з Hubert",
            "Subtitle": "Отримуйте поради щодо покращення проходження співбесід і роботи.",
            "PickedForMe": "Останні статті",
            "ButtonText_SeeAllArticles": "Переглянути всі статті"
        },
        "HubertTip": {
            "Title": "Порада від Hubert",
            "Subtitle": "Проходьте співбесіди швидше",
            "Description": "Подаєтеся на нову роботу на подібну роль, для якої ви вже проходили співбесіду з Hubert? Ви можете повторно використати свої відповіді з попередньої співбесіди й заощадити час.",
            "ButtonText_ReadMoreTips": "Читати більше порад"
        },
        "NewCandidateModalPopup": {
            "Title": "Усе готово!",
            "DescriptionLine1": "Ваш обліковий запис готовий.",
            "DescriptionLine2": "Керуйте своїми співбесідами та профілем. Дивіться результати, отримуйте відгуки та дізнавайтеся, як краще проходити співбесіди.",
            "ButtonText_LetsGo": "Поїхали"
        },
        "InterviewCompletedModal": {
            "Title": "Чудова робота!",
            "Subtitle": "Ви завершили співбесіду.",
            "Description": "Рекрутери переглянуть усі заявки та нададуть відгук електронною поштою або телефоном, щойно в них буде оновлення.",
            "ButtonText_Continue": "Продовжити"
        },
        "LatestJobPostings": {
            "Title": "Останні вакансії",
            "Subtitle": "Ознайомтеся з іншими пропозиціями від партнерів Hubert, які нещодавно з’явилися."
        }
    },
    "MyInterviews": {
        "MyInterviewsSection_Title": "Мої співбесіди",
        "MyInterviewsSection_Subtitle": "Виберіть співбесіду, щоб переглянути оцінювання та свої кар’єрні можливості.",
        "MyInterviewsSection_ToDo": "Завдання"
    },
    "Interview": {
        "ButtonText_SeeAllInterviews": "Переглянути всі співбесіди",
        "InterviewNotFound_Title": "Доступ заборонено",
        "InterviewNotFound_Description": "Ви намагаєтеся отримати доступ до деталей співбесіди, що не пов’язані з вашим обліковим записом.",
        "ButtonText_GoToAllInterviews": "Перейти до «Мої співбесіди»",
        "InterviewDetails": {
            "Title": "Деталі співбесіди",
            "ForRole": "На посаду",
            "InterviewCompletedOn": "Співбесіду завершено {{date}} о {{time}}"
        },
        "MyResult": {
            "Title": "Мій результат",
            "Subtitle": "Оцінена відповідність",
            "ButtonText_LearnMore": "Перегляньте, як оцінюються ваші відповіді",
            "GotPotential_Title": "Є потенціал, бракує вимоги",
            "GotPotential_Description": "Ваші відповіді вказують на сильний потенціал для цього типу ролі. Однак, згідно з цією співбесідою, ви можете не відповідати одній або кільком кваліфікаційним вимогам для цієї конкретної вакансії. Це може вплинути на наступні кроки, залежно від потреб рекрутера та пулу кандидатів. Якщо вас не запросять на наступний етап, знайте, що це не відображає ваш потенціал як кандидата. Часто справа просто в пошуку точної відповідності конкретним потребам ролі. Перегляньте інші можливості та поради щодо вдосконалення нижче.",
            "GotPotential_DescriptionSecondary": "Оцінка Hubert носить рекомендаційний характер. Рішення про запрошення на наступний етап процесу найму приймає рекрутер, і інші фактори, такі як кількість кандидатів, також можуть вплинути на результат.",
            "GreatMatch_Title": "Сильна відповідність",
            "GreatMatch_Description": "Ваші відповіді добре узгоджуються з тим, що рекрутери зазвичай шукають для цієї ролі, і ви відповідаєте вимогам вакансії. Чудова робота. Рекрутер перегляне всіх кандидатів і вирішить щодо наступних кроків.",
            "GreatMatch_DescriptionSecondary": "Оцінка Hubert носить рекомендаційний характер. Рішення про запрошення на наступний етап процесу найму приймає рекрутер, і інші фактори, такі як кількість кандидатів, також можуть вплинути на результат. Якщо вас не запросять на наступний етап, знайте, що це не відображає ваш потенціал як кандидата. Часто справа просто в пошуку точної відповідності конкретним потребам ролі. Перегляньте інші можливості та поради щодо вдосконалення нижче.",
            "OkMatch_Title": "Кваліфікований, додайте більше впливу",
            "OkMatch_Description": "Ви відповідаєте вимогам вакансії. Щоб виділитися, вашим відповідям може знадобитися трохи більше ясності та конкретики порівняно з тим, що рекрутери зазвичай бачать для цієї ролі. Перегляньте свої відповіді нижче і подивіться, де додавання одного конкретного прикладу або результату може підвищити вашу оцінку.",
            "OkMatch_DescriptionSecondary": "Оцінка Hubert носить рекомендаційний характер. Рішення про запрошення на наступний етап процесу найму приймає рекрутер, і інші фактори, такі як кількість кандидатів, також можуть вплинути на результат.",
            "NotClearMatch_Title": "Поки що потрібна більша ясність",
            "NotClearMatch_Description": "Згідно з цією співбесідою, ваші відповіді можуть бути менш узгоджені з тим, що шукає рекрутер для цієї ролі, і ви можете не відповідати одній або кільком вимогам. Якщо ви хочете вдосконалитися, почніть із запитань нижче. Невеликі зміни, більше конкретики та чіткі результати можуть мати велике значення наступного разу.",
            "NotClearMatch_DescriptionSecondary": "Оцінка Hubert носить рекомендаційний характер. Рішення про запрошення на наступний етап процесу найму приймає рекрутер, і інші фактори, такі як кількість кандидатів, також можуть вплинути на результат."
        },
        "ScoreBox": {
            "ProfessionalExperiences": "Професійний досвід, мотивації та компетенції",
            "QualifyingRequirements": "Кваліфікаційні вимоги для цієї конкретної роботи",
            "NotQualified_Title": "Область для вдосконалення",
            "NotQualified_Description": "Ваші відповіді могли виглядати менш конкретними або орієнтованими на результат, ніж очікує рекрутер для цієї ролі. Подивіться нижче місця, де додавання конкретного прикладу, дій, які ви виконали, або чіткого результату може посилити ваші відповіді.",
            "GreatResults_Title": "Сильні відповіді",
            "GreatResults_Description": "Ваші відповіді вказують на те, що ви добре підходите для цього типу ролі і висловлювались чітко. Якщо якесь запитання можна було б покращити, ви побачите його виділеним нижче.",
            "MeetingRequirements_Title": "Вимоги виконано",
            "MeetingRequirements_Description": "Ваші відповіді вказують на те, що ви відповідаєте кваліфікаційним вимогам, які рекрутер встановив для цієї роботи. Гарна основа.",
            "NotAllExpectationsMet_Title": "Одна або більше вимог відсутні",
            "NotAllExpectationsMet_Description": "На основі ваших відповідей ви можете не відповідати одній або кільком кваліфікаційним вимогам для цієї конкретної роботи, наприклад, сертифікати, ліцензії, рівень освіти або роки досвіду.",
            "ButtonText_FindOutPossibleReasons": "Переглянути деталі"
        },
        "ScriptFromInterview": {
            "Title": "Прочитати повну співбесіду",
            "ButtonText_SeeWholeTranscript": "Читати співбесіду",
            "ButtonText_DeleteInterview": "Видалити співбесіду",
            "Loading_Title": "Завантаження...",
            "Loading_Subtitle": "Зачекайте, ми завантажуємо стенограму вашої співбесіди."
        },
        "HowToImproveAtInterviews": {
            "Title": "Як покращити проходження співбесід",
            "Subtitle_Questions": "Ось деякі запитання, відповіді на які потенційно можна покращити.",
            "Subtitle_NoQuestions": "Жодних конкретних відповідей не було позначено. Ось найкращі способи додати впливу для цієї ролі.",
            "GreatMatch_Questions_Description": "Навіть якщо ви сильна відповідність, деякі відповіді все одно можна посилити. Якщо ми виявили такі, ви знайдете їх нижче. Дотримуйтесь інструкцій перед кожним запитанням. Описуючи ситуацію, включайте ситуацію, що ви зробили, і результат. Уникайте дуже коротких відповідей. Прагніть до чітких і конкретних описів, як на очній співбесіді.",
            "GreatMatch_NoQuestions_Description": "Ви добре впоралися зі своїми запитаннями. Чудова робота.",
            "OkMatch_Questions_Description": "Нижче ви знайдете запитання, відповіді на які можна покращити. Дотримуйтесь інструкцій перед кожним запитанням. Описуючи ситуацію, включайте ситуацію, що ви зробили, і результат. Уникайте дуже коротких відповідей. Прагніть до чітких і конкретних описів, як на очній співбесіді.",
            "OkMatch_NoQuestions_Description": "Ваші відповіді були грунтовними, але ця роль може бути конкурентною. Це означає, що навіть хороші відповіді можуть опинитися посередині.",
            "OkMatch_NoQuestions_DescriptionSecondary": "Наступного разу прагніть до ясності та впливу. Почніть з результату, додайте один реальний приклад і будьте лаконічними, зазвичай від 3 до 6 речень. Будьте конкретними щодо того, що ви зробили, як ви це зробили і що змінилося завдяки цьому.",
            "GotPotential_Questions_Description": "Навіть якщо ви виглядаєте сильним кандидатом для цього типу роботи, деякі відповіді все одно можна посилити. Якщо ми виявили такі, ви знайдете їх нижче. Дотримуйтесь інструкцій перед кожним запитанням. Описуючи ситуацію, включайте ситуацію, що ви зробили, і результат. Уникайте дуже коротких відповідей. Прагніть до чітких і конкретних описів, як на очній співбесіді.",
            "GotPotential_NoQuestions_Description": "Ми не знайшли відповідей, які потребують значного покращення щодо професійних компетенцій та мотивації. Здається, ви добре відповіли на ці теми.",
            "NotClearMatch_Questions_Description": "Нижче ви знайдете запитання, відповіді на які можна покращити. Дотримуйтесь інструкцій перед кожним запитанням. Описуючи ситуацію, включайте ситуацію, що ви зробили, і результат. Уникайте дуже коротких відповідей. Прагніть до чітких і конкретних описів, як на очній співбесіді.",
            "NotClearMatch_NoQuestions_Description": "Ми не знайшли жодної «поганої» відповіді. Справа більше в загальній узгодженості з тим, що потрібно для цієї ролі. Якщо конкуренція сильна, невеликі прогалини можуть мати значення.",
            "NotClearMatch_NoQuestions_DescriptionSecondary": "Для наступної співбесіди зосередьтеся на конкретиці. Виберіть один приклад на запитання, поясніть свої дії та поділіться результатом. Коротко і конкретно зазвичай краще, ніж довго і загально.",
            "Alert_WantMoreAdvice": "Хочете більше порад, як добре пройти співбесіду з Hubert?",
            "AlertLink_ExploreOurGeneralAdviceArticle": "Перегляньте нашу статтю із загальними порадами"
        },
        "SimilarOffers": {
            "Title": "Подібні пропозиції"
        },
        "HowHubertScoresInterviews": {
            "Title": "Як Hubert оцінює співбесіди?",
            "Description": "Нижче наведено короткий опис того, як Hubert оцінює відповіді на співбесіді. Ми також додали розділ «Процес найму», щоб пояснити, як виглядають наступні кроки після співбесіди з Hubert.",
            "Tabs_PossibleOutcomes": "Можливі результати",
            "Tabs_RecruitmentProcess": "Процес найму",
            "AssessedMatch_Title": "Оцінена відповідність",
            "AssessedMatch_Description": "Hubert оцінює, наскільки ваші відповіді загалом відповідають тому, що рекрутери зазвичай шукають для цієї ролі. Разом із вимогами до ролі ви побачите один із наведених нижче результатів.",
            "AssessedMatch_DescriptionSecondary": "Оцінка Hubert носить рекомендаційний характер. Рішення про запрошення на наступний етап процесу найму приймає рекрутер, і інші фактори, такі як кількість кандидатів, також можуть вплинути на результат.",
            "GreatMatch_Title": "Сильна відповідність",
            "GreatMatch_Description": "Ваші відповіді добре узгоджуються з тим, що шукають рекрутери, і ви відповідаєте вимогам. Чудова робота. Рекрутер перегляне кандидатів і вирішить щодо наступних кроків.",
            "GotPotential_Title": "Сильний потенціал, бракує вимоги",
            "GotPotential_Description": "Ваші відповіді вказують на сильний потенціал. Однак ви можете не відповідати одній або кільком необхідним кваліфікаціям. Це може вплинути на наступні кроки, залежно від потреб рекрутера.",
            "OkMatch_Title": "Кваліфікований, додайте більше впливу",
            "OkMatch_Description": "Ви відповідаєте вимогам. Щоб виділитися, вашим відповідям може знадобитися більше ясності та конкретики. Використовуйте відгуки у вашій співбесіді, щоб посилити свої приклади в майбутньому.",
            "NotClearMatch_Title": "Поки що потрібна більша ясність",
            "NotClearMatch_Description": "Згідно з цією співбесідою, ваші відповіді можуть бути менш узгоджені з тим, що шукає рекрутер, і ви можете не відповідати одній або кільком вимогам. Перегляньте свої відповіді, щоб побачити, де ви можете додати ясності та прикладів.",
            "ProfessionalExperiences_Title": "Професійний досвід, мотивації та компетенції",
            "ProfessionalExperiences_Description": "Це запитання про ваш попередній досвід, вашу мотивацію до роботи та компетенції, що стосуються ролі. Рекрутери вирішують, які запитання використовуються.",
            "GreatResults_Title": "Сильні відповіді",
            "GreatResults_Description": "Ваші відповіді вказують на те, що ви добре підходите для цього типу ролі і висловлювались чітко. Якщо якесь запитання можна було б покращити, ви побачите його виділеним.",
            "NotQualified_Title": "Область для вдосконалення",
            "NotQualified_Description": "Ваші відповіді могли бути менш конкретними або орієнтованими на результат. Шукайте виділені місця, де додавання конкретного прикладу або чіткого результату може посилити ваші відповіді.",
            "QualifyingRequirements_Title": "Базові або кваліфікаційні вимоги",
            "QualifyingRequirements_Description": "Це запитання, які рекрутер визначив як кваліфікаційні вимоги, наприклад, необхідний сертифікат, водійське посвідчення або певний рівень досвіду.",
            "MeetingRequirements_Title": "Вимоги виконано",
            "MeetingRequirements_Description": "Ваші відповіді вказують на те, що ви відповідаєте кваліфікаційним вимогам, які встановив рекрутер. Гарна основа.",
            "NotAllExpectationsMet_Title": "Одна або більше вимог відсутні",
            "NotAllExpectationsMet_Description": "На основі ваших відповідей ви можете не відповідати одній або кільком кваліфікаційним вимогам для цієї конкретної роботи.",
            "RecruitmentProcess_Title": "Процес найму",
            "RecruitmentProcess_Description": "Hubert зазвичай використовується як перший крок у процесі найму з багатьма кандидатами. Це дає можливість кожному пройти співбесіду та розповісти більше про себе. Оскільки запитання однакові для всіх, процес є більш послідовним. Hubert не використовує таку інформацію, як вік, стать або зовнішність, що зменшує ризик несвідомої упередженості.",
            "EventOne_Title": "Вас співбесідує Hubert",
            "EventOne_Description": "Ви проходите співбесіду тоді і там, де вам зручно. Обмежень за часом немає, і ви можете зробити перерву в будь-який момент.",
            "EventTwo_Title": "Вашу співбесіду оцінюють",
            "EventTwo_Description": "Hubert оцінює ваші відповіді за допомогою сучасних технологій. Щойно оцінювання буде завершено, результати будуть доступні вам тут у My Hubert, а також рекрутеру.",
            "EventThree_Title": "Рекрутер обирає кандидатів",
            "EventThree_Description": "Рекрутери бачать, коли доступний новий результат. Вони можуть переглянути ваші відповіді та оцінку Hubert. Спираючись на рекомендаційну оцінку та власне судження, вони вирішують, чи запросять вас на наступний крок (дзвінок, тест, фінальна співбесіда). Якщо інші кандидати краще відповідають вимогам, вашу заявку можуть відхилити.",
            "ButtonText_Close": "Закрити"
        }
    },
    "MyProfile": {
        "Title": "Мій профіль",
        "MyDetails": {
            "Title": "Мої дані",
            "Label_FirstName": "Ім’я",
            "Label_LastName": "Прізвище",
            "Label_Email": "Електронна пошта",
            "Label_PhoneNumber": "Номер телефону",
            "ButtonText_UpdateDetails": "Оновити дані",
            "Error_FirstName_Required": "Ім’я є обов’язковим.",
            "Error_LastName_Required": "Прізвище є обов’язковим.",
            "Error_Email_Required": "Електронна пошта є обов’язковою.",
            "Error_Email_Invalid": "Введіть дійсну адресу електронної пошти.",
            "Error_PhoneNumber_Invalid": "Номер телефону недійсний.",
            "Success_Details_Updated": "Профіль оновлено."
        },
        "ChangePassword": {
            "Title": "Змінити пароль",
            "Set_Password_Title": "Створити пароль",
            "Label_CurrentPassword": "Поточний пароль",
            "Label_NewPassword": "Новий пароль",
            "Label_RepeatNewPassword": "Повторіть новий пароль",
            "Alert_SignInAgain": "Будь ласка, увійдіть знову, щоб встановити пароль.",
            "ButtonText_UpdatePassword": "Оновити пароль",
            "ButtonText_SetPassword": "Встановити пароль",
            "ButtonText_SignInAgain": "Увійти знову",
            "Error_CurrentPassword_Required": "Поточний пароль є обов’язковим.",
            "Error_CurrentPassword_DoesntMatch": "Пароль не збігається з поточним паролем.",
            "Error_NewPassword_Required": "Новий пароль є обов’язковим.",
            "Error_NewPassword_6_Characters": "Ваш новий пароль має містити щонайменше 6 символів.",
            "Error_RepeatNewPassword_Required": "Потрібно повторити новий пароль.",
            "Error_RepeatNewPassword_DoesntMatch": "Пароль не збігається з новим паролем.",
            "Success_Password_Changed": "Пароль оновлено.",
            "Error_Invalid_CurrentPassword": "Недійсний поточний пароль."
        },
        "NotificationPreferences": {
            "Title": "Налаштування сповіщень",
            "Label_ReceiveUpdatesToggle": "Я хочу отримувати оновлення від Hubert.",
            "Label_ReceiveUpdatesToggleHelpText": "Ви отримуватимете кар’єрні гайди, поради щодо співбесід та інше."
        },
        "AccountRemoval": {
            "Title": "Видалення облікового запису",
            "ButtonText_RemoveMyAccount": "Видалити мій обліковий запис"
        }
    },
    "PreInterviewPage": {
        "Title_Hello": "Привіт",
        "Subtitle": "Ви збираєтеся розпочати свою співбесіду.",
        "TipBox_Title": "Ось кілька порад, які можуть допомогти.",
        "TipBox_Tip1": "Проходьте співбесіду в спокійному місці, щоб зосередитися.",
        "TipBox_Tip2": "Відповідайте з комп’ютера з клавіатурою (якщо тільки ви не звикли багато писати на телефоні).",
        "TipBox_Tip3": "Будьте якомога конкретнішими та детальними. Hubert і рекрутери хочуть добре вас пізнати.",
        "TipBox_Tip4": "Не поспішайте. Обмежень за часом немає.",
        "TipBox_Tip5": "Ви можете зробити перерву в будь-який момент і продовжити з того місця, де зупинилися.",
        "TipBox_Tip6": "Будьте собою й ставтеся до співбесіди з Hubert так само серйозно, як до реальної співбесіди.",
        "CheckAdviceArticle_Text1": "Якщо хочете більше порад, як досягти успіху на співбесіді, перегляньте цю",
        "CheckAdviceArticle_Text2": "статтю",
        "CheckAdviceArticle_Text3": "з чудовими порадами.",
        "ReadyToGetStarted": "Готові розпочати?",
        "ORSeparator_Text": "Або",
        "ButtonText_StartInterviewNow": "Почати співбесіду",
        "ButtonText_SetReminder": "Я ще не готовий(-а), встановити нагадування",
        "PrivacyPolicyText": "Натискаючи «почати співбесіду», ви погоджуєтеся з",
        "PrivacyPolicyLink": "Політикою конфіденційності та Умовами використання"
    },
    "InterviewCompletedPageInviteEmail": {
        "CompletedAlert_Title": "Чудова робота!",
        "CompletedAlert_Subtitle": "Ви завершили співбесіду.",
        "CompletedAlert_Description": "Рекрутери переглянуть усі заявки та нададуть відгук електронною поштою або телефоном, щойно в них буде оновлення.",
        "InterviewNotCompleted": "Цю співбесіду не завершено."
    },
    "HelpCenter": {
        "BannerSection": {
            "Title": "Центр допомоги",
            "Subtitle": "Дізнайтеся відповіді на найчастіші запитання про Hubert.",
            "Label_Search": "шукати відповіді на часті запитання",
            "ButtonText_Search": "Пошук"
        },
        "FAQSection": {
            "Tabs_All": "Усе",
            "Tabs_AboutHubertInterview": "Про співбесіду з Hubert",
            "Tabs_TechnicalSupport": "Технічна підтримка"
        },
        "StillHaveQuestion": {
            "Title": "Все ще маєте запитання?",
            "Description": "Ми з радістю допоможемо.",
            "DropUsAEmail": "Напишіть нам на hubert@hubert.ai"
        },
        "Q&ATexts": {
            "AboutHubertInterview": [
                {
                    "q": "Чи можу я пройти співбесіду телефоном?",
                    "a": "Наразі Hubert працює лише в режимі чату. Якщо у вас є медичні обмеження, зверніться безпосередньо до компанії-роботодавця."
                },
                {
                    "q": "Чи можу я пройти співбесіду іншою мовою?",
                    "a": "У деяких співбесідах є можливість обрати мову на початку. Якщо такої опції немає, розуміння мови співбесіди, ймовірно, є вимогою. За додатковими питаннями звертайтеся до компанії-роботодавця."
                },
                {
                    "q": "Чи будуть мене карати за короткі відповіді?",
                    "a": "Ні, якщо ви відповідаєте належним чином. Але деталі часто допомагають."
                },
                {
                    "q": "Чи можу я повторно використати свої відповіді з іншої співбесіди з Hubert?",
                    "a": "Так, якщо ви увійшли до My Hubert і подаєтеся на подібну роль."
                },
                {
                    "q": "Чи читатиме мою співбесіду людина?",
                    "a": "Так, наших клієнтів просять вручну перевіряти співбесіди."
                },
                {
                    "q": "Я пройшов(-ла) співбесіду. Що далі?",
                    "a": "Результати надсилаються рекрутеру. Вони переглядають ваші відповіді та оцінку, і вирішують щодо наступного кроку (дзвінок, тест, співбесіда)."
                },
                {
                    "q": "У мене є питання про наступні кроки. До кого звертатися?",
                    "a": "Будь ласка, зверніться до компанії, куди ви подавалися."
                },
                {
                    "q": "Як ви гарантуєте відсутність упередженості?",
                    "a": "Hubert послідовний і не знає про гендер, вік чи зовнішність, що зменшує упередженість."
                },
                {
                    "q": "Чи можу я пройти співбесіду з людиною?",
                    "a": "Зверніться до компанії, щоб дізнатися про це."
                },
                {
                    "q": "Чи є Hubert людиною?",
                    "a": "Ні, Hubert є комп’ютерною системою."
                },
                {
                    "q": "Чи можу я змінити відповіді пізніше?",
                    "a": "Ні, як і на реальній співбесіді, переробити відповіді не можна."
                },
                {
                    "q": "Як досягти успіху?",
                    "a": "Читайте уважно, дотримуйтесь інструкцій, наводьте реальні приклади і будьте чесними."
                },
                {
                    "q": "Мені потрібна робота. До кого звернутися?",
                    "a": "Зверніться до компанії, куди ви подавалися."
                },
                {
                    "q": "Я не отримав відповіді. Що робити?",
                    "a": "Рекрутери вирішують щодо наступних кроків. Якщо інші кандидати підходять краще, ви можете не перейти до наступного етапу. За оновленням можете звернутися до рекрутера."
                },
                {
                    "q": "У мене є досвід, але я не отримав роботу. Чому?",
                    "a": "Конкуренція може бути високою. Запитайте компанію про причини або перегляньте My Hubert для порад."
                },
                {
                    "q": "Скільки часу триває співбесіда?",
                    "a": "Від 10 до 25 хвилин. Не поспішайте."
                },
                {
                    "q": "Де прочитати про обробку даних?",
                    "a": "https://www.hubert.ai/candidate-privacy-policy"
                }
            ],
            "TechnicalSupport": [
                {
                    "q": "Чому я не бачу попередніх співбесід?",
                    "a": "Переконайтеся, що ви використовуєте ту саму електронну пошту, що й у заявці (включаючи вхід через Google)."
                },
                {
                    "q": "Чому я не отримав листа?",
                    "a": "Перевірте спам. Або створіть обліковий запис My Hubert з поштою заявки, щоб знайти посилання."
                },
                {
                    "q": "Не можу знайти посилання в пошті.",
                    "a": "Перевірте спам. Або увійдіть до My Hubert і перевірте «Мої співбесіди»."
                },
                {
                    "q": "Чи працює на мобільному?",
                    "a": "Так! Але комп’ютер може бути зручнішим для друку."
                },
                {
                    "q": "Не працює. Що робити?",
                    "a": "Напишіть на hubert@hubert.ai."
                },
                {
                    "q": "Хочу видалити обліковий запис. Що робити?",
                    "a": "Напишіть на hubert@hubert.ai."
                },
                {
                    "q": "Перервалося. Як повернутися?",
                    "a": "Натисніть посилання в листі або увійдіть до My Hubert."
                }
            ]
        }
    },
    "LearnWithHubert": {
        "BannerSection": {
            "Title": "Навчайтеся з Hubert",
            "Subtitle": "Дізнайтеся, як збільшити свої шанси та краще працювати.",
            "Label_Search": "шукати гайди",
            "ButtonText_Search": "Пошук"
        },
        "TabSelector": {
            "MyFeed": "Моя стрічка",
            "InterviewGuides": "Гайди зі співбесід",
            "CareerGuides": "Кар’єрні гайди"
        },
        "NewestOnTheFeed": "Нове",
        "PickedForMe": "Останні статті",
        "InterviewGuides": "Гайди зі співбесід",
        "CareerGuides": "Кар’єрні гайди"
    },
    "Article": {
        "ButtonText_BackToAllArticles": "До всіх статей"
    },
    "ForgotPassword": {
        "ResetLinkAlert_Title": "Скидання пароля",
        "ResetLinkAlert_Subtitle": "Натисніть посилання в листі, щоб встановити новий пароль.",
        "PasswordNotSetAlert_Message": "Пароль не встановлено, увійдіть через ",
        "ResetYourPassword": {
            "MainTitle": "Хочете побачити результати своєї співбесіди з Hubert?",
            "Subtitle": "Увійдіть, щоб бачити результати, отримувати відгуки та інше.",
            "FormSectionTitle": "Скинути пароль",
            "Label_NewPassword": "Новий пароль",
            "Label_ConfirmNewPassword": "Підтвердити пароль",
            "Error_NewPassword_Required": "Введіть новий пароль.",
            "Error_Password_6_Characters": "Пароль має містити щонайменше 6 символів.",
            "Error_ConfirmNewPassword_Required": "Підтвердьте пароль.",
            "Error_ConfirmNewPassword_NotMatch": "Паролі не збігаються.",
            "Error_MalformedResetUrl": "Недійсний код безпеки. Спробуйте ще раз.",
            "Error_ResetPasswordFailed": "Помилка скидання. Спробуйте ще раз.",
            "Error_WeakPassword": "Пароль має містити щонайменше 6 символів.",
            "Error_InvalidCode_Title": "Запит прострочений або недійсний.",
            "Error_InvalidCode_Subtitle": "Спробуйте скинути пароль ще раз.",
            "ButtonText_SetNewPassword": "Встановити та увійти",
            "ButtonText_RememberYourPassword": "Пам’ятаєте пароль?",
            "ButtonText_SignInInstead": "Увійти натомість"
        }
    },
    "PageNotFound": {
        "Title": "Сторінку не знайдено",
        "Description": "Ми не можемо знайти сторінку, яку ви шукаєте.",
        "ButtonText_GoToDashboard": "До панелі керування",
        "ButtonText_GoToLogin": "До входу"
    },
    "OldInterviewRedirectionModal": {
        "DescriptionLine1": "Повторне використання відповідей поки що недоступне для цієї співбесіди. Очікуємо, що це стане можливим незабаром, але ви можете пройти співбесіду зараз.",
        "DescriptionLine2": "Будь ласка, перейдіть до співбесіди, натиснувши кнопку нижче.",
        "ButtonText_TakeMeToTheInterview": "Перейти до співбесіди"
    },
    "UnsubscribeFromEmails": {
        "Title": "Ви впевнені?",
        "Subtitle": "Ви перестанете отримувати листи про цю вакансію:",
        "SelectTheReason": "Виберіть причину.",
        "ReasonText1": "Я знайшов(-ла) іншу роботу.",
        "ReasonText2": "Мене більше не цікавить ця вакансія.",
        "ReasonText3": "Інше",
        "ButtonText_Unsubscribe": "Скасувати підписку",
        "Placeholder_YourReason": "Ваша причина",
        "Success_Title": "Ви успішно відписалися.",
        "Loading": "Завантаження...",
        "Error_YourReason_Required": "Введіть причину.",
        "Error_ServerIssue": "Не вдалося відписатися через помилку сервера."
    },
    "SocialLoginCallback": {
        "ButtonText_TryAgain": "Спробувати ще раз"
    },
    "Outreach": {
        "CandidateNotFound": "Кандидата не знайдено",
        "CandidateNotFoundDesc": "Не вдалося знайти потрібні деталі співбесіди.",
        "InterviewEnded": "Співбесіду завершено",
        "InterviewEndedDesc1": "Цей сеанс співбесіди завершився або більше недоступний.",
        "InterviewEndedDesc2": "Дякуємо за ваш час. Якщо маєте запитання, зверніться до команди з підбору персоналу.",
        "ReadyTitle": "Готові до співбесіди, {{firstName}}?",
        "InvitationDesc": "Hubert від імені {{companyName}} запрошує вас на чат-співбесіду. Це займе приблизно 1–2 хвилини.",
        "Button_StartChat": "Почати чат-співбесіду",
        "CancelNotice": "Якщо розпочнете тут, запланований дзвінок щодо цієї вакансії буде скасовано.",
        "PreferNotToContinue": "Не бажаєте продовжувати?",
        "DeclineLabel": "Мене не цікавить ця вакансія. Будь ласка, більше не телефонуйте й не пишіть мені щодо цієї позиції.",
        "Button_ConfirmAndDecline": "Підтвердити й відмовитися",
        "Processing": "Обробка...",
        "Toast_DeclineSuccess": "Співбесіду відхилено.",
        "Toast_CancelVoiceInfo": "Дзвінок скасовано. Функція незабаром з’явиться.",
        "Toast_CancelError": "Не вдалося скасувати дзвінок. Спробуйте ще раз.",
        "Footer_WithdrawConsent": "Ви можете відкликати згоду будь-коли. Детальніше — у ",
        "Footer_PrivacyPolicySuffix": "політиці конфіденційності",
        "Footer_And": " та ",
        "Footer_HubertPrivacyLink": "Політиці конфіденційності Hubert та Умовах використання",
        "Chat_InterviewWith": "Співбесіда з {{companyName}}",
        "Chat_StatusConnected": "Підключено",
        "Chat_StatusError": "Помилка",
        "Chat_StatusDisconnected": "Відключено",
        "Chat_StatusConnecting": "Підключення...",
        "Chat_ReadyToStart": "Готові розпочати співбесіду?",
        "Chat_ButtonStart": "Почати співбесіду",
        "Chat_SayHello": "Скажіть «Привіт», щоб почати розмову.",
        "Chat_EmptyState": "Надішліть повідомлення, щоб розпочати співбесіду.",
        "Chat_SelectLanguage": "Оберіть свою мову",
        "Chat_Placeholder": "Введіть повідомлення...",
        "Chat_ButtonSend": "Надіслати",
        "Chat_ButtonBack": "Назад",
        "LoadingCandidateDetails": "Завантажуємо дані кандидата...",
        "FetchingCandidateDetails": "Отримуємо дані кандидата...",
        "Chat_StatusReady": "Очікуємо підключення...",
        "Chat_ForbiddenError": "Ця чат-співбесіда більше недоступна.",
        "Chat_GeneralError": "Не вдалося почати чат. Будь ласка, спробуйте пізніше.",
        "Chat_SelectUiLanguage": "Мова меню",
        "Chat_InterviewTitle": "Співбесіда"
    }
}
